var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"container d-flex"},[_c('a',[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logoFrontLeft,"alt":"Logo Left"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }